import {RWSService} from '@rws-framework/client';
//this is a Chat service from angularJS not AI chat
export class JunctionChatService extends RWSService {
  static _IN_CLIENT: boolean = true;
   defaultEventOptions = {
    bubbles: true,
    composed: true,
    cancelable: true
  };
  connection = undefined;
  connection_meta = undefined;
  userId = undefined;
  status = 'offline';
  idle_interval = undefined;
  userAuthDeferred = [];
  userAuthDeferredInProgress = false;
  firebaseApiURL = window.edrnaConfig.firebase.apiURL;
  initChatMessageDownloadingCount = 40;
  coursesChat = {};
  unreadCount = {count: 0};
  user = undefined;
  onUserOnline = new Function();
  onUserIdle = new Function();
  onUserOffline = new Function();

  //to get user
  _dispatch(type: string, detail?: object, options?: object) {
    return document.documentElement.dispatchEvent(new CustomEvent(type, Object.assign(Object.assign({
      detail
    }, this.defaultEventOptions), options)));
  }
  getUser(): Promise<any> {
    return new Promise((resolve) => {
      this._dispatch('jnct:junctionuser:getuser', (data: any) => {
        resolve(data)
      })
    })
  };

  //define in component
  unreadMessageInRoomChange = function(arr1) {};
  trueUpMessagesHandler = function(res){}
    
  async loadUserData(connection) {
    if (this.user) {
      return new Promise((resolve, reject) => {
        resolve(this.user);
      });
    };
    if (this.userAuthDeferredInProgress) {
      const deferred: { promise: Promise<any>, resolve: (value?: any) => void, reject: (reason?: any) => void } = {} as any;
      deferred.promise = new Promise<any>((resolve, reject) => {
          deferred.resolve = resolve;
          deferred.reject = reject;
      });
      this.userAuthDeferred.push(deferred);
      return deferred.promise;
    };
    this.userAuthDeferredInProgress = true;
    return Promise.all([
      this.getUser(),
      // firebase_token
      fetch(`${window.edrnaConfig.host}${window.edrnaConfig.serverPrefix}firebase_token/`).then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
    ])
    .then(([user, tokenResponse]) => {
      const token = tokenResponse.token;
      const deferred: { promise: Promise<any>, resolve: (value?: any) => void, reject: (reason?: any) => void } = {} as any;
      deferred.promise = new Promise((resolve, reject) => {
        deferred.resolve = resolve;
        deferred.reject = reject;
      });
    
      connection.authWithCustomToken(token, (error, authData) => {
        this.userAuthDeferredInProgress = false;
        if (error) {
          console.error("Login to Firebase Failed!", error);
          this.userAuthDeferred.forEach((d) => d.reject(error));
          deferred.reject(error);
        } else {
          this.user = user;
          this.userId = authData.uid;
          this.userAuthDeferred.forEach((d) => d.resolve(this.user));
          deferred.resolve(this.user);
        }
      });
    
      return deferred.promise;
    })
    .catch(error => {
      console.error('Error fetching data:', error);
      throw error; // Re-throw to propagate the error to the caller
    });
  };

  setStatus(newStatus: string, course) {
    if (this.status === newStatus) return;
    this.status = newStatus;
    if (this.status === 'offline') return;
    
    this.loadUserData(this.connection).then((user) => {
      if (course !== undefined) {
        const setObject = {
          id: user.mongoId,
          status: this.status
        };
        let userRef = course.userRef;
        if (userRef == undefined) userRef = course.usersRef.child(user.mongoId);
        course.status = newStatus;
        userRef.set(setObject);
      };
    });
  };

  online(course) {
    if (this.status === 'online' && (course === undefined || course.status !== 'online')) return;
  
    this.connect(this.firebaseApiURL);
    this.setStatus('online', course);

    clearInterval(this.idle_interval);
    this.idle_interval = setInterval(()=>  {
      this.idle(course);
    }, 10000);
  };

  idle(course) {
    if (this.status === 'idle' && (course === undefined || course.status !== 'idle')) return;
    this.connect(this.firebaseApiURL);
    this.setStatus('idle', course);
  };

  offline(course = undefined) {
    if (this.status === 'offline' && (course === undefined || course.status !== 'offline')) return;
    this.disconnect();
    this.setStatus('offline', course);
    clearInterval(this.idle_interval);
  };

  initMessaging(courseChat) {
    this.loadUserData(this.connection).then((user) => {
      this.listenForInvites(courseChat);
      this.addToRoomsListMessagesForAllStudents(courseChat);
    })
  };

  listenForInvites(courseChat) {
    const userInvitesRef = courseChat.invitesRef.child(this.userId);   
    userInvitesRef.on('child_added', (snapshot) => {
      const newRoomInvite = snapshot.key();
      const courseChatIsReadRef = courseChat.groupsRef.child(newRoomInvite).child('isRead');
      const roomMembers = this.getRoomMembers(newRoomInvite);
      const secondUserId = roomMembers[0] == this.userId ? roomMembers[1] : roomMembers[0];
      courseChat.rooms[newRoomInvite] = {
        messages: [],
        isReadByMeRef: courseChatIsReadRef.child(this.userId),
        isReadBySecondUserRef: courseChatIsReadRef.child(secondUserId)
      };
      this.listenForUnReadMessages(courseChat.rooms[newRoomInvite].isReadByMeRef, secondUserId);
    });
  };

  // THIS IS THE ONE EMITTING THE UNREAD COUNTS PER INVITE ENTRY AND ON NEW ENTRIES
  listenForUnReadMessages(isReadRef, secondUserName: string) {
    const unreadMessageCountRef = isReadRef.child('unreadMessageCount');
    unreadMessageCountRef.on('value', (snapshot)=>  {
      const newUnReadCount = snapshot.val();

      if (newUnReadCount !== null) {
        this.unreadMessageInRoomChange({
          unreadMessageCount: newUnReadCount,
          secondUserName: secondUserName
        });
      }
    })
  };

  getRoomMembers(roomName: string) {
    return roomName.split('_and_');
  }

  addToRoomsListMessagesForAllStudents(courseChat) {
    const allStudentsMessagesRef = courseChat.messagesToAllStudents.messagesRef;
    const allStudentsIsReadRef = courseChat.messagesToAllStudents.isReadRef;
    const allStudentsIsReadByMeRef = allStudentsIsReadRef.child(this.userId);

    courseChat.rooms['messagesToAllStudents'] = {
      messages: [],
      isReadByMeRef: allStudentsIsReadByMeRef,
      roomRef: allStudentsMessagesRef
    };

    this.listenRoomForMessages('messagesToAllStudents', courseChat, allStudentsMessagesRef);
    this.listenForUnReadMessages(allStudentsIsReadByMeRef, 'notifications');
  };

  listenRoomForMessages(roomName: string, courseChat, customMessagesRef = undefined): Promise<void> {
    const messagesRef = customMessagesRef || courseChat.groupsRef.child(roomName).child('messages');
    const lastAddedMessage = {
      timestamp: undefined,
      key: undefined
    };

    return new Promise((resolve) => {

    courseChat.rooms[roomName].getOldMessages = (count) => {
      const deferred: { promise: Promise<any>, resolve: (value?: any) => void, reject: (reason?: any) => void } = {} as any;
      deferred.promise = new Promise<any>((resolve, reject) => {
        deferred.resolve = resolve;
        deferred.reject = reject;
      });
      let isFirstMessage = true;
      const oldLastAddedMessage = {
        timestamp: lastAddedMessage.timestamp,
        key: lastAddedMessage.key
      };
      let insertBeforeIndex = 0;

      messagesRef.orderByChild("timestamp").endAt(lastAddedMessage.timestamp).limitToLast(count + 1).on('child_added', (snapshot) => {
        const message = snapshot.val();

        if (snapshot.key() !== oldLastAddedMessage.key) {
          if (isFirstMessage) {
            lastAddedMessage.timestamp = message.timestamp;
            lastAddedMessage.key = snapshot.key();
            isFirstMessage = false;
          }

          if (message.from === this.userId) message.from = 'me';
          message.last_updated = message.timestamp;
          courseChat.rooms[roomName].messages.splice(insertBeforeIndex, 0, $.extend(message,{
            date: new Date(message.timestamp)
          }));

          if (insertBeforeIndex === count - 1) {
            deferred.resolve({'downloadingMessagesCompleted': true});
          }

          insertBeforeIndex++;
        } else {
          deferred.resolve({'downloadingMessagesCompleted': true});
        }
      });

      return deferred.promise
    };
    
      const messagesRef = customMessagesRef || courseChat.groupsRef.child(roomName).child('messages');
      const lastAddedMessage = { timestamp: undefined, key: undefined };

      let firstMessageReceived = false;

      // Timeout to resolve even if no messages arrive
      const timeout = setTimeout(() => {
        if (!firstMessageReceived) {
          resolve(); // Resolve with no messages
        }
      }, 400); // Adjust timeout as needed (4 seconds)

    messagesRef.orderByChild("timestamp").limitToLast(this.initChatMessageDownloadingCount).on('child_added', (snapshot) => {
      const message = snapshot.val();
      if (!lastAddedMessage.key) {
        lastAddedMessage.timestamp = message.timestamp;
        lastAddedMessage.key = snapshot.key();
      }
      if (message.from === this.userId) message.from = 'me';

      courseChat.rooms[roomName].messages.push({
        ...message,
        date: new Date(message.timestamp)
      });

      if (!firstMessageReceived) {
        firstMessageReceived = true;
        clearTimeout(timeout); // Stop the timeout if a message arrives
        resolve();
      }
    });
  });
};

  trueUpMessages(courseChat, scope=undefined) {
    const userInvitesRef = courseChat.invitesRef.child(this.userId);
    const allStudentsIsReadRef = courseChat.messagesToAllStudents.isReadRef;
    const allStudentsIsReadByMeRef = allStudentsIsReadRef.child(this.userId);
    const all = [];
     
    all.push(this.trueUpUnReadMessages(allStudentsIsReadByMeRef, 'notifications'));

    const deferred: { promise: Promise<any>, resolve: (value?: any) => void, reject: (reason?: any) => void } = {} as any;
    deferred.promise = new Promise<any>((resolve, reject) => {
      deferred.resolve = resolve;
      deferred.reject = reject;
    });

    setTimeout(() => {
      userInvitesRef.once('value', (snapshot) => {
        const invites = snapshot.val() || {};
        Object.keys(invites).forEach((key) => {
          const roomMembers = key.split('_and_');
          const secondUserId = roomMembers[0] == this.userId ? roomMembers[1] : roomMembers[0];
          all.push(this.trueUpUnReadMessages(courseChat.rooms[key].isReadByMeRef, secondUserId));
        });
        Promise.all(all).then((results) => {
          this.trueUpMessagesHandler(results);
          deferred.resolve();
        });
      });
      return deferred.promise;
    }, 20)
  };

  trueUpUnReadMessages(isReadRef, secondUserName) {
  const deferred: { promise: Promise<any>, resolve: (value?: any) => void, reject: (reason?: any) => void } = {} as any;
  deferred.promise = new Promise<any>((resolve, reject) => {
      deferred.resolve = resolve;
      deferred.reject = reject;
  });
      var unreadMessageCountRef = isReadRef.child('unreadMessageCount');
      const me = isReadRef.child('messages');
      
      unreadMessageCountRef.on('value', (snapshot) => {
          var newUnReadCount = snapshot.val();
          deferred.resolve({
              unreadMessageCount: newUnReadCount || 0,
              secondUserName: secondUserName
          });
      });
      return deferred.promise;
  };

  inviteUsersToRoom(usersIds: string[], roomName: string, courseChat) {
    usersIds.forEach((user_id) => {
      courseChat.invitesRef.child(user_id).child(roomName).set('true');
    });
  };

  getCourseChats(courseId: string) {
    return this.coursesChat[courseId];
  };

  getPrivateRoom(secondUserId, courseChat, fromUserId: string | undefined = undefined) {
    const deferred: { promise: Promise<any>, resolve: (value?: any) => void, reject: (reason?: any) => void } = {} as any;
    deferred.promise = new Promise<any>((resolve, reject) => {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    fromUserId = fromUserId || this.userId;
    const chatPossibleNames = [fromUserId + '_and_' + secondUserId, secondUserId + '_and_' + fromUserId].sort();

    const createOption = () => {
      const chatRef = courseChat.groupsRef.child(chatPossibleNames[0]);
      chatRef.set({
        firstUser: fromUserId,
        secondUser: secondUserId
      }, (error) =>  {
        if (error) {
          deferred.reject(error);
          return;
        }
        this.inviteUsersToRoom([fromUserId, secondUserId], chatPossibleNames[0], courseChat);
        deferred.resolve(chatRef);
      });
    };

    courseChat.invitesRef.child(fromUserId).once('value', (snapshot)=> {
      const roomy = snapshot.val() || [];
      if (roomy[chatPossibleNames[0]]) {
        deferred.resolve(courseChat.groupsRef.child(chatPossibleNames[0]))
      } else if (roomy[chatPossibleNames[1]]) {
        deferred.resolve(courseChat.groupsRef.child(chatPossibleNames[1]))
      } else {
        createOption();
      }
    }, (error) => {
      createOption();
    });

    return deferred.promise;
  };

  async loadPrivateChat(courseId: string, secondUserId: string, scope): Promise<any> {
    try {
      await this.loadUserData(this.connection);

      this.connectToCourseChat(courseId);

      if (secondUserId === 'notifications') {
        return this.coursesChat[courseId].rooms['messagesToAllStudents'].messages;
      }
  
      await this.getPrivateRoom(secondUserId, this.coursesChat[courseId]);
  
      const courseChat = this.getCourseChats(courseId);
      const roomName = courseChat.getRoomName(secondUserId);
      const rooms = await this.getRoom(courseId, secondUserId);
  
      if (!rooms.messages.length) {
        await this.listenRoomForMessages(roomName, courseChat); // Now we wait for messages!
      }
  
      return rooms.messages;
    } catch (error) {
      console.error("Error loading private chat:", error);
      return [];
    }
  }
  
  

  getRoom(courseId: string, secondUserId: string) {
    const courseChats = this.getCourseChats(courseId);
    const roomName = courseChats.getRoomName(secondUserId);
    if (secondUserId === 'notifications') {
      return courseChats.rooms['messagesToAllStudents'];
    } else {
      return courseChats.rooms[roomName];
    };
  };

  setConversationAsRead(courseId: string, secondUserId: string) {
    const room = this.getRoom(courseId, secondUserId);
    let isReadByMeRef;
    if (room) {
      isReadByMeRef = room.isReadByMeRef;
      setTimeout(() => {
        if (room.messages.length > 0) {
          isReadByMeRef.once('value', (snapshot) => {
            const isRead = snapshot.val();
            if (isRead !== null) {
              isReadByMeRef.set({
                is: true,
                unreadMessageCount: 0
              });
              this.unreadMessageInRoomChange({
                unreadMessageCount: 0,
                secondUserName: secondUserId
              });
            }
          });
        }
      }, 10)
    }
  };

  sendPrivateMessage(message, courseId: string, secondUserId: string) {
    this.coursesChat[courseId].sendMessageTo(secondUserId, message);
  };

  //probable is not used anymore
  sendMultiplePrivateMessage(message, courseId: string, student_ids) {
    student_ids.forEach(id => {
      this.coursesChat[courseId].sendMessageTo(id, message);
    })
  };

  //message from junctionbot, for course alerts in messages panel
   sendBotMessage(message, courseId: string, secondUserId: string) {
    this.coursesChat[courseId].sendBotMessageTo(secondUserId, message);
  };

  updateMessage(message ,courseId: string) {
    this.coursesChat[courseId].updateMessage(message);
  };

  sendMessageToAllStudents(message, courseId: string) {
    const course = this.coursesChat[courseId];
    const toAllStudentsRoom = course.rooms['messagesToAllStudents'];
    const usersRef = course.usersRef;

    toAllStudentsRoom.roomRef.push({
      from: this.userId,
      message: message,
      timestamp: Firebase.ServerValue.TIMESTAMP
    });

    usersRef.once('value', (snapshot) => {
      const users = snapshot.val();
      const isReadRef = course.messagesToAllStudents.isReadRef;

      Object.keys(users).forEach((secondUserName) => {
        if (secondUserName != this.userId) {
          const isReadBySecondUserRef = isReadRef.child(secondUserName);

          isReadBySecondUserRef.once('value', (snapshot) => {
            const isRead = snapshot.val();
            let newCount = 0;

            if (isRead !== null &&  isRead.unreadMessageCount !== undefined) {
              newCount = isRead.unreadMessageCount;
            }

            isReadBySecondUserRef.set({
              is: false,
              unreadMessageCount: newCount + 1
            });
          });
        }
      });
    });
  };

  setUserStatus(status: string, secondUserId: string) {
    if (status === 'online') this.onUserOnline(secondUserId);
    if (status === 'idle') this.onUserIdle(secondUserId);
    if (status === 'offline') this.onUserOffline(secondUserId);
  };

  listenForOtherUsersStatusChanges(usersRef) {
    // on first load, let's set all the relevant statuses rather than wait for status changes to update
    usersRef.once('value', (snapshot) => {
      if (snapshot.val() && snapshot.val().length) {
        snapshot.val().forEach((user) => {
          if (user.status !== "offline") {
            this.setUserStatus(user.status, user.id)
          }
        })
      }
    });

    usersRef.on('child_added', (snapshot) => {
      const user = snapshot.val();
      const userStatus = user.status;
      const userId = user.id;
      this.setUserStatus(userStatus, userId);
    });

    usersRef.on('child_changed', (snapshot) => {
      const user = snapshot.val();
      const  userStatus = user.status;
      const userId = user.id;
      this.setUserStatus(userStatus, userId);
    });

    usersRef.on('child_removed', (snapshot) => {
      const user = snapshot.val();
       this.onUserOffline(user.id);
    });
  };

  onAppDisconnect(userRef) {
    this.connection_meta.on('value', (snapshot) => {
      if (snapshot.val()) {
        userRef.onDisconnect().update({ status: 'offline' });
      }
    });
  };

  connectToCourseChat(courseId: string) {
    if (this.coursesChat[courseId]) {
      this.online(this.coursesChat[courseId]);
      if (!this.userId) {
        return this.loadUserData(this.connection).then((user) => {
          return this.trueUpMessages(this.coursesChat[courseId]);
        });
      } else {
        return this.trueUpMessages(this.coursesChat[courseId]);
      }
    } else {
      const courseRef = this.connection.child('courses/' + courseId);
      const email_queue = this.connection.child('email_queue');
      // TODO add proper typing for courseChat to avoid square bracket access
      const courseChat = this.coursesChat[courseId] = {
        invitesRef: courseRef.child('invites'),
        usersRef: courseRef.child('users'),
        groupsRef: courseRef.child('groups'),
        messagesToAllStudents: {
          messagesRef: courseRef.child('messagesToAllStudents').child('messages'),
          isReadRef: courseRef.child('messagesToAllStudents').child('isRead')
        },
        rooms: [],
        status: this.status
      };

      return this.loadUserData(this.connection).then((user) => {
        const userObject = {
          id: user.mongoId,
          status: this.status
        };

        this.userId = userObject.id;
        this.trueUpMessages(this.coursesChat[courseId]);
        courseChat['userRef'] = courseChat.usersRef.child(userObject.id);
        courseChat['userRef'].set(userObject);
        this.online(courseChat);
        this.onAppDisconnect(courseChat['userRef']);
        this.listenForOtherUsersStatusChanges(courseChat.usersRef);
        courseChat['sendBotMessageTo'] = (secondUserName: string, message) => {

          this.getPrivateRoom(secondUserName, courseChat, 'junctionbot').then((chatRef)=>  {
            const isReadBySecondUserRef = chatRef.child('isRead').child(secondUserName);

            chatRef.child('messages').push($.extend(message, {
              from: 'junctionbot',
              timestamp: Firebase.ServerValue.TIMESTAMP
            }));

            isReadBySecondUserRef.once('value', (snapshot)=> {
              const isReadObj = snapshot.val();
              let newUnReadMessageCount = 1 + (isReadObj? isReadObj.unreadMessageCount : 0);
              isReadBySecondUserRef.set({
                is: false,
                unreadMessageCount: newUnReadMessageCount
              });
            });
          });
        };
        courseChat['sendMessageTo'] = (secondUserName: string, message) => {
          this.getPrivateRoom(secondUserName, courseChat).then((chatRef) => {
            const isReadBySecondUserRef = this.getRoom(courseId, secondUserName).isReadBySecondUserRef;

            chatRef.child('messages').push({
              from: this.userId,
              message: message,
              timestamp: Firebase.ServerValue.TIMESTAMP
            });

            /* Email Queue Add */
            if (window.labelBundle.notifications) {
              const _time = new Date();
              email_queue.child(window.labelBundle.host.replaceAll('.', '_')).push({
                  from: this.userId,
                  to: secondUserName,
                  type: "message", // mention, reply
                  location: `#/${courseId}`,
                  message: message,
                  timestamp: _time.toISOString(),
              });
            };

            isReadBySecondUserRef.once('value', (snapshot)=>  {
              const isReadObj = snapshot.val();
              let oldUnReadMessageCount = 0;

              if (isReadObj !== null) {
                oldUnReadMessageCount = snapshot.val().unreadMessageCount;
              }

              isReadBySecondUserRef.set({
                is: false,
                unreadMessageCount: oldUnReadMessageCount + 1
              });
            });
        });
        };

        courseChat['getRoomName'] = (secondUserId: string) => {
          const chatPossibleNames = [(this.userId + '_and_' + secondUserId), secondUserId + '_and_' + this.userId];

          if (courseChat.rooms[chatPossibleNames[0]] !== undefined) {
            return chatPossibleNames[0];
          } else {
            return chatPossibleNames[1];
          }
        };

        courseChat['updateMessage'] = (message) => {
          this.getPrivateRoom('junctionbot', courseChat).then((chatRef) => {
            chatRef.child('messages').orderByChild('timestamp').equalTo(message.date.getTime()).once('child_added', (snapshot)=>  {
              const messageRef = snapshot.child('message').ref();
              messageRef.set(message.message)
            })
          })
        };
        this.initMessaging(courseChat);
      });
    }
  };

  connect(url: string): void {
    Firebase.goOnline();
    if (this.connection) return;
    this.connection = new Firebase(url);
    this.connection_meta = new Firebase(url + '/.info/connected');
  };

  disconnect() {
    Firebase.goOffline();
    this.connection = undefined;
    this.connection_meta = undefined;
  };

  userList = {};
  setUserList(course, aList) {
    this.userList[course] = aList;
  };

  getUserList(course) {
    return this.userList[course] || {};
  }
}

export default JunctionChatService.getSingleton()

export {JunctionChatService as JunctionChatServiceInstance}
